// import Personnel from './Personnel';

export default {
  // component: Personnel,
  component: load(() => import(/* webpackChunkName: "Personnel" */ './Personnel')),
  priority: 9,
  permissions: ['BasicInformationMenu/PersonnelMenu'],
  name: app.translate('routes.home.Personnel'),
  icon: 'account',
  drawer: true,
};
